<template>
  <div v-if="showModal" class="modal">
    <div class="modal-content">
      <span @click="$emit('close')" class="close">&times;</span>
      <p class="fs-4 bold">[ 입금내역 검색 ]</p>

      <div class="text-primary text-start fs-6 mb-2">
        <b>[ &nbsp; 검색조건 &nbsp; ]</b>&nbsp;&nbsp;<i style="font-size: small; color:gray">(최근 4개월 이내 입금내역만 조회됩니다)</i>
      </div>
      <table class="table table-bordered border-secondary align-middle w-100 h-auto text-center" style="font-size: smaller;">
        <tbody>
          <tr>
            <th class="table-secondary" style="width:15%;">입금자</th>
            <td style="width:85%;">
              <input type="text" class="form-control form-control-sm" ref="depositorInput" v-model="depositorName" maxlength="40" placeholder="입금자명(부분검색 가능)" @keyup.enter="searchDeposit">
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-end mb-3">
        <button type="button" class="btn btn-outline-danger btn-sm" ref="searchBtn" @click="searchDeposit">검색(ENTER)</button>
      </div>

      <div class="text-success text-start fs-6 mb-2"> 
        <b>[ &nbsp; 입금내역리스트 &nbsp; ]</b>
        <span style="font-size:smaller; color:gray" v-if="searched">&nbsp;({{ depositInfoList.length }}건)</span>
      </div>
      <table class="table table-bordered table-striped fs-6" style="font-size:smaller;">
        <thead class="small">
          <tr>
            <th style="width:9%;">정산처</th>
            <th style="width:8%;">입금일</th>
            <th style="width:10%;">입금자</th>
            <th style="width:15%;">입금내역</th>
            <th style="width:8%;">입금은행</th>
            <th style="width:9%;">입금액</th>
            <th style="width:9%;">잔액</th>
            <th style="width:14%;">메모사항</th>
            <th style="width:18%;" v-if="targetDealCode">처리</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="searched && depositInfoList.length === 0">
            <td :colspan="targetDealCode ? 9 : 8" class="text-secondary">검색된 입금내역이 없습니다.</td>
          </tr>
          <tr :key="i" v-for="(di, i) in depositInfoList">
            <td>{{ getPartnerName(di.sellerCode) }}</td>
            <td>{{ di.depositDate }}</td>
            <td>
              <a @click="goToSuppliment_detail(di.exDepositNo)" style="cursor:pointer" class="text-primary">{{ di.depositor }}</a>
            </td>
            <td class="text-start">{{ di.depositDetail }}</td>
            <td>{{ getBankName(di.finCd) }}</td>
            <td class="text-end">{{ di.depositAmt }}</td>
            <td class="text-end" :class="di.balanceAmt > 0 ? 'text-danger fw-bold' : 'text-secondary'">
              {{ getCurrencyFormat(di.balanceAmt) }}
            </td>
            <td class="text-start">{{ di.depositMemo }}</td>
            <td v-if="targetDealCode">
              <button type="button" class="btn btn-outline-primary btn-sm m-1" @click="applyPayment(di, 'AL')" :disabled="currentPayAmt > 0 || di.balanceAmt < totalSalePrice">전액
              </button>
              <button type="button" class="btn btn-outline-success btn-sm m-1" @click="applyPayment(di, 'PA')" :disabled="remainingBalance <= 0 || di.balanceAmt <= 0 || getDiPaidAmt(di) > 0">부분
              </button>
              <button type="button" class="btn btn-outline-danger btn-sm m-1" @click="applyPayment(di, 'CX')" :disabled="getDiPaidAmt(di) <= 0">취소</button>
              <div v-if="getDiPaidAmt(di) > 0" style="font-size:0.65rem; color:#0d6efd;">매칭액: {{ getCurrencyFormat(getDiPaidAmt(di)) }}원</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['showModal', 'modalContent'],
  data() {
    return {
      depositorName: "",        //입금자검색어(유일한 검색조건)

      partnerInfo: [],          //결과 리스트의 "정산처" 컬럼 표시용
      finBankingInfo: [],       //결과 리스트의 "입금은행" 컬럼 표시용

      depositInfoList: [],
      searched: false,          //검색 실행 여부(결과없음 안내 표시 제어용)

      //판매내역 행에서 넘어온 매칭대상 판매건 컨텍스트
      targetDealCode: "",
      targetSubNo: null,
      targetSalePrice: 0,
      targetSaleFee: 0,
      targetSaleMemo: "",
      currentPayAmt: 0,         //현재 이 판매건의 누적입금액(로컬상태, 처리 성공 시 즉시 갱신)
      paidDepositNo: "",        // 실제로 매칭에 쓰인 입금건 코드 - 취소는 반드시 이 건에서만 가능
      payHistory: [],           // 이 판매건(dealCode+subNo)에 실제 매칭된 입금이력 - 건별 취소/재입금 판단용
    }
  },
  created() {
    this.user = this.$store.state.user

    this.getPartnerList()
    this.getFinBankingInfo()

    if(this.modalContent)
    {
      this.targetDealCode = this.modalContent.dealCode || ""
      this.targetSubNo = this.modalContent.subNo
      this.targetSalePrice = this.modalContent.salePrice * 1 || 0
      this.targetSaleFee = this.modalContent.saleFee * 1 || 0
      this.targetSaleMemo = this.modalContent.saleMemo || ""
      this.currentPayAmt = this.modalContent.payAmt * 1 || 0
    }

    this.loadPayHistory()   // 판매건에 이미 매칭된 입금이력 조회 - 취소/재입금 판단용
  },
  mounted() {
    document.addEventListener("keydown",this.handleEnterKeyPress);

    //모달이 열릴 때 입금자 인풋박스에 자동 포커스
    this.$nextTick(() => {
      if(this.$refs.depositorInput) this.$refs.depositorInput.focus()
    })
  },
  beforeUnmount() {
    document.removeEventListener("keydown",this.handleEnterKeyPress);
  }, 
  computed: {
    //총판매가(판매액-수수료) - 입금매칭 기준액
    totalSalePrice() {
      return this.targetSalePrice - this.targetSaleFee
    },
    //판매건에 이미 입금처리된 금액이 있는지 - 전액/부분 잠금, 취소 활성화 제어용
    hasExistingPayment() {
      return this.currentPayAmt > 0
    },
    //판매건의 잔여미수 - 이 값이 0 이하면 완납
    remainingBalance() {
      return this.totalSalePrice - this.currentPayAmt
    }
  },
  methods: {
    getDateFormat(date) {
      return this.$dateFormat(date)
    },
    getCurrencyFormat(value) {
      return this.$currencyFormat(value)
    },
    getDeCurrencyFormat(value) {
      return this.$deCurrencyFormat(value)
    },

    //엔터키(검색) / ESC키(모달닫기) 바로작동
    handleEnterKeyPress(event)
    {
      if(event.keyCode === 13)
      {
        this.$refs.searchBtn.click();
      }
      else if(event.keyCode === 27)
      {
        this.$emit('close')
      }
    },    

    async getPartnerList(){
      let partnerInfo_tmp = await this.$api("/api/partnerInfo", {})
      if(partnerInfo_tmp.length > 0)
      {
        this.partnerInfo = partnerInfo_tmp.filter(item => item.inCdFlag === "Y")
      }
    },

    async getFinBankingInfo(){
      let finBankingInfo_tmp = await this.$api("/api/finBankingInfo", {param: ['Inst', 'Bank', 'Y']})
      if(finBankingInfo_tmp.length > 0)
      {
        this.finBankingInfo = finBankingInfo_tmp.filter(item => item.inCdFlag === "Y")
      }
    },

    getPartnerName(pCode){
      let found = this.partnerInfo.find(p => p.pCode === pCode)
      return found ? found.pName : pCode
    },

    getBankName(fCode){
      let found = this.finBankingInfo.find(f => f.fCodeNo === fCode)
      return found ? found.fName : fCode
    },

    //이 판매건(dealCode+subNo)에 실제 매칭된 입금이력 조회 - 취소 시 전체리셋이 아닌 건별 차감을 위해 필요
    async loadPayHistory(){
      if(!this.targetDealCode || !this.targetSubNo) return

      let payHistory = await this.$api("/api/getDealHistoryPay_s", {param: [this.targetDealCode, this.targetSubNo]})
      this.payHistory = (payHistory || []).filter(p => p.payUseFlag !== 'N')
    },

    //특정 입금건(di)이 이 판매건에 실제로 매칭한 금액 - 없으면 0
    getDiPaidAmt(di){
      return this.payHistory
        .filter(p => p.exDepositNo === di.exDepositNo)
        .reduce((sum, p) => sum + (p.payAmt * 1 || 0), 0)
    },

   //최근 4개월(고정) 입금내역 검색, 입금자명 단일조건
    async searchDeposit(){
      if(!this.depositorName || this.depositorName.trim() === "")
      {
        this.$swal.fire("","입금자명을 입력하세요.","warning")
        this.$refs.depositorInput.focus()
        return false
      }

      let today = new Date()
      let startDate = new Date()
      startDate.setMonth(startDate.getMonth() - 4)

      let dSearchStart = startDate.toISOString().slice(0, 10)
      let dSearchEnd = today.toISOString().slice(0, 10)

      let partnerCode = "all"
      let minMoney = 0
      let maxMoney = 999999999
      let depositD = ""
      let depositMm = ""
      let finCd = ""
      let exDepoCode = ""

      let depositInfoList = await this.$api("/api/proc_searchDepositHistory", {param: [
        partnerCode, dSearchStart, dSearchEnd, this.depositorName, minMoney, maxMoney, depositD, depositMm, finCd, exDepoCode
      ]})

      this.searched = true

      if(!depositInfoList || !depositInfoList[1] || depositInfoList[1].length === 0)
      {
        this.depositInfoList = []
        return
      }

      this.depositInfoList = depositInfoList[1].map(di => {
        di.depositAmt_raw = di.depositAmt * 1        //잔액계산용 원본 숫자값 보관
        di.depositDate = this.getDateFormat(di.depositDate)
        di.depositAmt = this.getCurrencyFormat(di.depositAmt)
        di.balanceAmt = di.depositAmt_raw            //잔액 로딩 전 기본값(=입금액 전체)
        return di
      })

      if(this.targetDealCode)
      {
        await this.loadBalances()
      }
    },

    //검색결과 각 입금건의 분할가능잔액(=depositAmt - 기존 분할적용 합계) 일괄 조회
    async loadBalances(){
      let promises = this.depositInfoList.map(di =>
        this.$api("/api/getExdepositSplitHistory", {param: [di.exDepositNo]}).catch(() => [])
      )
      let results = await Promise.all(promises)

      results.forEach((history, idx) => {
        let sumSplit = (history || []).reduce((acc, e) => acc + Math.trunc(parseFloat(e.splitDepositAmt) || 0), 0)
        this.depositInfoList[idx].balanceAmt = Math.trunc(this.depositInfoList[idx].depositAmt_raw) - sumSplit
      })
    },

    //처리 성공 후, 해당 한 건만 잔액 재계산(전체 재조회보다 가벼움)
    async refreshBalance(di){
      let history = await this.$api("/api/getExdepositSplitHistory", {param: [di.exDepositNo]}).catch(() => [])
      let sumSplit = (history || []).reduce((acc, e) => acc + Math.trunc(parseFloat(e.splitDepositAmt) || 0), 0)
      di.balanceAmt = Math.trunc(di.depositAmt_raw) - sumSplit
    },

    async applyPayment(di, payType){
      let diPaidAmt = this.getDiPaidAmt(di)

      if(payType === 'AL' && this.currentPayAmt > 0)
      {
        this.$swal.fire("", "이미 일부 입금처리된 판매건입니다.<br>부분입금으로 잔액을 처리해주세요.", "warning")
        return
      }

      if(payType === 'PA' && diPaidAmt > 0)
      {
        this.$swal.fire("", "이 입금건은 이미 이 판매건에 매칭되어 있습니다.<br>취소 후 다시 진행해주세요.", "warning")
        return
      }

      if(payType !== 'CX' && this.remainingBalance <= 0)
      {
        this.$swal.fire("", "이미 전액 입금처리된 판매건입니다.", "warning")
        return
      }

      let targetPayAmt = 0
      let confirmMsg = ""
      let iconType = "question"

      if(payType === 'AL')
      {
        targetPayAmt = this.totalSalePrice

        if(targetPayAmt > di.balanceAmt)
        {
          this.$swal.fire("", "이 입금건의 잔액(" + this.getCurrencyFormat(di.balanceAmt) + "원)이 총판매가(" + this.getCurrencyFormat(targetPayAmt) + "원)보다 부족합니다.<br>부분입금을 이용해주세요.", "warning")
          return
        }
        confirmMsg = "전액입금(" + this.getCurrencyFormat(targetPayAmt) + "원) 처리하시겠습니까?"
      }
      else if(payType === 'PA')
      {
        const { value: inputAmt } = await this.$swal.fire({
          html: `추가 입금액 입력(필수)<br><span style="font-size:small; color:gray;">판매건 잔여미수: ${this.getCurrencyFormat(this.remainingBalance)}원 / 이 입금건 잔액: ${this.getCurrencyFormat(di.balanceAmt)}원</span>`,
          input: 'text',
          inputPlaceholder: "숫자만 입력"
        })

        if(!inputAmt) return

        let incrementAmt = this.getDeCurrencyFormat(inputAmt) * 1

        if(!incrementAmt || incrementAmt <= 0)
        {
          this.$swal.fire("", "입금처리할 금액을 입력해주세요.", "warning")
          return
        }

        if(incrementAmt > di.balanceAmt)
        {
          this.$swal.fire("", "이 입금건의 분할가능잔액(" + this.getCurrencyFormat(di.balanceAmt) + "원)을 초과합니다.", "warning")
          return
        }

        targetPayAmt = this.currentPayAmt + incrementAmt

        if(targetPayAmt > this.totalSalePrice)
        {
          confirmMsg = "판매건 잔여미수(" + this.getCurrencyFormat(this.remainingBalance) + "원)를 초과하는 금액입니다.<br>과오납으로 처리하시겠습니까?"
          iconType = "warning"
        }
        else
        {
          confirmMsg = "추가입금(" + this.getCurrencyFormat(incrementAmt) + "원) 처리하시겠습니까?<br>처리 후 누적입금액: " + this.getCurrencyFormat(targetPayAmt) + "원"
        }
      }
      else if(payType === 'CX')
      {
        if(diPaidAmt <= 0)
        {
          this.$swal.fire("", "이 입금건에서 처리된 입금이 없습니다.", "warning")
          return
        }

        //전체를 0으로 리셋하는 게 아니라, 이 입금건의 매칭분만 차감 - 다른 입금건의 매칭은 그대로 보존
        targetPayAmt = this.currentPayAmt - diPaidAmt
        confirmMsg = "이 입금건으로 처리된 " + this.getCurrencyFormat(diPaidAmt) + "원을 취소하시겠습니까?"
        iconType = "warning"
      }

      let confirm = await this.$swal.fire({
        html: confirmMsg,
        icon: iconType,
        showCancelButton: true,
        confirmButtonText: "확인",
        cancelButtonText: "취소"
      })
      if(!confirm.isConfirmed) return

      let param = "DS"
      let simpleName = ""
      let dFlag = "D"
      let dCurCd = "KRW"
      let dExRate = 1
      let dPayMethod = "Bank"
      let finCd = di.finCd
      let dPayCode = finCd
      let dFeeRate = 0
      let dUseFlag = "Y"
      let splitFlag = "Y"
      let exUseFlag = "Y"

      let res = await this.$api("/api/proc_createExdepositSplit", {param: [
        param, simpleName,
        di.exDepositNo, this.targetDealCode, 0, this.user.handlerId, exUseFlag, this.targetSaleMemo, finCd, this.user.handlerId,
        dFlag, dCurCd, dExRate, 0, dPayMethod, dPayCode, dFeeRate, this.targetSaleMemo, di.depositor, di.depositDate, dUseFlag,
        splitFlag, this.modalContent.custName, this.targetSubNo, targetPayAmt, payType
      ]})

      if(Object.keys(res)[0] === "error")
      {
        this.$swal.fire("", "입금처리 실패(" + res.error.sqlMessage + ")", "error")
        return
      }

      this.$swal.fire("", "입금처리가 완료되었습니다.", "success")

      this.currentPayAmt = targetPayAmt
      this.$emit('applied')

      await this.loadPayHistory()   //건별 매칭상태 최신화(다른 입금건 버튼 활성화 여부에 반영)
      await this.refreshBalance(di)
    },

    // 입금코드기반으로 검색할 수 있도록 새 창에서 열기 - businessInfo_detail.vue와 동일 패턴
    goToSuppliment_detail(lnk_exCode){
      let routeData = this.$router.resolve({path: "/supExSettlement", query: {lnk_exCode: lnk_exCode}})
      window.open(routeData.href, '_blank')
    },
  }
}
</script>

<style scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
}
.modal-content {
  background-color: #fff;
  padding: 1rem;
  border-radius: 0.3rem;
  max-height: 80vh;
  overflow-y: auto;
  width: 90vw;
  box-sizing: border-box;
  position: relative;
}
.close {
  position: absolute;
  top: 0.75rem;
  right: 1rem;
  color: #aaa;
  font-size: 22px;
  font-weight: bold;
  cursor: pointer;
  z-index: 1;
}
</style>